
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  className?: string;
  iconClassName?: string;
  index?: number;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ 
  icon: Icon, 
  title, 
  description, 
  className,
  iconClassName,
  index = 0
}) => {
  return (
    <div 
      className={cn(
        'group relative bg-card border border-border rounded-2xl p-6 transition-all duration-300',
        'hover:shadow-subtle hover:border-primary/20',
        'opacity-0 animate-fade-up',
        className
      )} 
      style={{ animationDelay: `${(index + 1) * 100}ms` }}
    >
      <div className={cn(
        'flex items-center justify-center w-12 h-12 rounded-xl mb-5',
        'bg-primary/10 text-primary transition-colors duration-300',
        'group-hover:bg-primary group-hover:text-white',
        iconClassName
      )}>
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
    </div>
  );
};

export default FeatureCard;
